<script setup lang="ts">
import { HttpStatus } from '@/core/enums/httpStatus';
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { NxtErrorPage } from '@nxtpeople/nxt-styles';

const { keycloak, isAuthenticated } = useKeycloak();
const { t } = useI18n();
const { state } = useStore();
const route = useRoute();
const router = useRouter();

// #region error message
const http_status = computed(() => {
   const statusCode = route.query.http_status_code;
   return typeof statusCode === 'string' ? HttpStatus[statusCode] : {};
});
const history = computed(() => state.history);
// #endregion

// #region redirect
function signOut() {
   keycloak.logout({ redirectUri: window.location.origin });
}

function redirectUser(force_sign_out = false) {
   if (force_sign_out) return signOut();

   switch (http_status.value.actions) {
      case 'sign_out':
         signOut();
         break;
      case 'return':
      case 'both':
         const REVERSE_HISTORY = history.value.reverse();
         const LAST_HISTORY_ITEM = REVERSE_HISTORY.find((item) => !item.includes('error'));

         if (!LAST_HISTORY_ITEM) return router.push({ path: '/' });
         if (LAST_HISTORY_ITEM.includes('board')) return router.push({ path: '/board' });
         if (LAST_HISTORY_ITEM.includes('pool')) return router.push({ path: '/pool' });
         if (LAST_HISTORY_ITEM.includes('candidate')) return router.push({ path: '/candidate' });
         if (LAST_HISTORY_ITEM.includes('communication')) return router.push({ path: '/communication' });
         if (LAST_HISTORY_ITEM.includes('dashboard')) return router.push({ path: '/dashboard' });
         if (LAST_HISTORY_ITEM.includes('customer')) return router.push({ path: '/customer' });
         if (LAST_HISTORY_ITEM.includes('badge')) return router.push({ path: '/badge' });
         break;

      default:
         break;
   }
}
// #endregion
</script>

<template>
   <div class="error">
      <NxtErrorPage
         :title="$t(`http.${http_status.name}_title`)"
         :message="$t(`http.${http_status.name}_message`)"
         :to-home-action-text="$t(`http.${http_status.name}_redirect`)"
         :show-logout-action="isAuthenticated && http_status.actions === 'both'"
         :logout-action-text="t('http.unauthorized_redirect')"
         @on-go-to-home="redirectUser()"
         @on-logout="redirectUser(true)"
      />
   </div>
</template>

<style lang="scss" scoped>
.error {
   height: 100%;
   width: 100%;
}
</style>

<style lang="scss">
.error .nxt-error-page__actions {
   margin-top: var(--nxt-gutter);
}
</style>
